import { setAuthToken } from '@common/api/axiosInstance';
import { ssoSwitchProperties } from '@common/api/hotel';
import { useAuthStore, useLogout, useHotelStore } from '@common/store/auth';
import { useNotificationsStore } from '@common/store/notifications';
import { ErrorResponse } from '@pages/Auth/SSO/types/error';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useSwitchProperties = () => {
  const { addNotification } = useNotificationsStore();
  const navigate = useNavigate();
  const { setHotelAuthToken } = useHotelStore();
  const { hotel, setHotel, setAuth, token } = useAuthStore();
  const clientLogout = useLogout();

  useEffect(() => {
    if (hotel && token) {
      navigate(`/client/calendar/${hotel}/pricing`);
    }
  }, [hotel, token, navigate]);

  const {
    mutate,
    isPending: isLoading,
    isSuccess
  } = useMutation({
    mutationFn: (propertiesCode: string) => ssoSwitchProperties(propertiesCode),
    onSuccess: (response) => {
      const { data } = response;
      const token = data?.data?.token;
      const id = data?.data?.id;
      const user = data?.data?.user ?? null;
      if (token) {
        setAuthToken(token);
        setAuth(token, user);
        setHotelAuthToken(token);
      }
      if (id) {
        setHotel(id);
      }
      addNotification('success', 'Switch Successful! Redirecting...');
    },
    onError: (error: AxiosError) => {
      clientLogout();
      let errorMessage = 'Failed Switch properties';
      const responseError = error.response?.data as ErrorResponse;
      if (responseError && responseError.errors) {
        errorMessage = responseError.errors[0]?.detail ?? errorMessage;
      }
      addNotification('fail', errorMessage);
    }
  });

  return {
    switchProperties: mutate,
    isSwitchPropertiesLoading: isLoading,
    isSuccess
  };
};
